import { bootstrapApplication } from '@angular/platform-browser';
import { cargarEntornoRuntime } from './environments/runtime-environment';
import { intentarSsoAlArrancar } from '@auth/services/pivi-session';
import {
  marcarArranqueCompletado,
  mostrarFalloDeArranque,
} from '@app/core/errors/fallo-de-arranque';

/**
 * Arranque en dos tiempos.
 *
 * `app.config` y `App` se importan de forma **dinámica y después** de resolver el
 * entorno: varios servicios capturan `environment.api` en una constante de módulo al
 * evaluarse, y con imports estáticos esos módulos correrían antes de que llegue la
 * configuración del contenedor.
 *
 * Si no hay `env.json` —que es el caso de `ng serve` y de los despliegues que no usan
 * Docker— `cargarEntornoRuntime()` no hace nada y manda el environment compilado.
 *
 * Luego, si no hay token local, se intenta entrar con la sesión central de PIVI (SSO
 * entre canales). Va después del entorno porque `piviBaseUrl` puede venir de
 * `env.json`, y antes de Angular para que `AuthService` nazca ya con el token (ver
 * `intentarSsoAlArrancar`). Nunca lanza y tarda como mucho 2 s.
 */
async function arrancar(): Promise<void> {
  await cargarEntornoRuntime();
  await intentarSsoAlArrancar();

  const [{ appConfig }, { App }] = await Promise.all([
    import('./app/app.config'),
    import('./app/app'),
  ]);

  await bootstrapApplication(App, appConfig);
  marcarArranqueCompletado();
}

// Si algo de lo anterior rechaza, la pantalla de fallo diagnostica la causa, se
// recupera sola cuando puede y, si no, lo explica. Ver `fallo-de-arranque.ts`.
arrancar().catch(mostrarFalloDeArranque);
